import {trafficSourceConstants} from "../constants/trafficSourceConstants";

const initialState = {
    data: {
        records: [],
        page: 0,
        recordsPerPage: 0,
        total: {}
    },
    errorMsg: "",
    isLoading: false,
    name: "",
    tags: [],
    orderBy: "",
    sortBy: "",
    sortColumns: [],
    rerender: false
};

const trafficSourceReducer = (state = initialState, action) => {
    switch (action.type) {
        case trafficSourceConstants.TRAFFIC_SOURCES_LOADING_SPINNER:
            return {
                ...state,
                isLoading: true,
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_STOP_LOADING_SPINNER:
            return {
                ...state,
                isLoading: false,
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_INFINITY_SCROLL:
            return {
                ...state,
                data: {
                    records: [...state.data.records, ...action?.result?.records],
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    total: action?.result?.total
                },
                errorMsg: '',
                isLoading: false
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_GET_DATA:
            return {
                ...state,
                data: {
                    records: action?.result?.records,
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    total: action?.result?.total
                },
                errorMsg: '',
                isLoading: false,
                rerender: false
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_ERROR:
            return {
                ...state,
                errorMsg: 'Unable to load traffic sources. Please try again.',
                rerender: false,
                isLoading: false,
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_ARCHIVE:
            return {
                ...state,
                rerender: true,
                isLoading: false,
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_RESTORE:
            return {
                ...state,
                rerender: true,
                isLoading: false,
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_UPDATE_ORDER_BY:
            return {
                ...state,
                orderBy: action.orderBy
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_UPDATE_SORT_BY:
            return {
                ...state,
                sortBy: action.sortBy
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_UPDATE_NAME:
            return {
                ...state,
                name: action.name
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_UPDATE_TAGS:
            return {
                ...state,
                tags: action.tags
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_UPDATE_SORT_COLUMNS:
            return {
                ...state,
                sortColumns: action.sortColumns
            };
        case trafficSourceConstants.TRAFFIC_SOURCES_RERENDER:
            return {
                ...state,
                rerender: true
            };
        case trafficSourceConstants.BULK_UPDATE_CHANGE_WORKSPACE:
            return {
                ...state,
                rerender: true,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default trafficSourceReducer;